<script>
	/**
	 * This top-level route serves as the teacher landing page and provides a
	 * Sign Up button.
	 *
	 * SUB ROUTES
	 *
	 * None.
	 *
	 */

	const utilities = require('utilities');
	const userContext = require('core/userContext');
	const accountService = require('services/accountService');
	const analyticsUtilities = require('utilities/analyticsUtilities');
	const fireEvent = analyticsUtilities.fireEvent;
	const HOMEPAGE_CLICK = analyticsUtilities.events.HOMEPAGE_CLICK;
	const alertUtilities = require('utilities/alertUtilities');
	const errorMessages = require('core/errorMessages');
	const { assetUrl } = require('utilities/urlUtilities');
	const pubsub = require('events/pubsub');

	module.exports = {
		props: ['route-context'],
		modelData: ['userContext'],
		components: {
			'authenticated-homepage': require('components/routes/authenticated-homepage.vue').default,
			'unauthenticated-homepage': require('components/routes/unauthenticated-homepage.vue').default
		},
		mounted() {
			var self = this;
			self.$watch(
				'routeContext.querystring',
				function () {
					var token = self.routeContext.parsedPath.getQueryParam('t');
					var errorCode = self.routeContext.parsedPath.getQueryParam('errorCode');
					if (self.routeContext.pathname === '/pwr' && token) {
						accountService
							.accountRecoveryCheck({
								token: token
							})
							.then(function (result) {
								userContext.initialize(result);

								pubsub.publish('logged-in');

								utilities.openModal('#modal-post-reset-password-change');
							})
							.fail(function () {
								utilities.closeModals();

								utilities.openModal('#modal-forgot-password');
							});
					} else if (errorCode && errorMessages[errorCode]) {
						alertUtilities.error(errorMessages[errorCode]);
					}
				},
				{
					immediate: true
				}
			);
		},
		methods: {
			homepageClick(loc) {
				fireEvent(HOMEPAGE_CLICK, {
					loc
				});
			},
			assetUrl(url) {
				return assetUrl(url);
			}
		}
	};
</script>
<template>
	<div>
		<unauthenticated-homepage
			class="main homepage"
			v-if="!userContext || userContext.classCode">
		</unauthenticated-homepage>
		<authenticated-homepage v-else> </authenticated-homepage>
		<password-modal
			confirm
			mode="teacher"
			modal-title="Reset Password"
			modal-id="modal-post-reset-password-change"></password-modal>
	</div>
</template>
